/** 
* @description 数据管理的基础库 跨框架使用的 数据管理获取 
* @version 0.3.1 
* @author lengyingxin <lengyingxin8966@gmail.com> (https://github.com/LengYXin)
*/
/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2019-08-23 11:24:19
 * @modify date 2019-08-23 11:24:19
 * @desc [枚举]
 */

/** x-client-info:platform={平台};version={版本号}  */
var EnumPlatform;

(function (EnumPlatform) {
  /** 桌面PC */
  EnumPlatform["desktop"] = "desktop";
  /** 手机H5 */

  EnumPlatform["mobile"] = "mobile";
  /** 后台管理 */

  EnumPlatform["bgm"] = "bgm";
  /** 微信小程序 */

  EnumPlatform["weapp"] = "weapp";
  /** 微信公众号 */

  EnumPlatform["wechat"] = "wechat";
})(EnumPlatform || (EnumPlatform = {}));
/**
 * 页面操作 枚举
 */


var EnumActionType;

(function (EnumActionType) {
  /** 详情 */
  EnumActionType["Info"] = "details";
  /** 添加 */

  EnumActionType["Insert"] = "insert";
  /** 修改编辑 */

  EnumActionType["Update"] = "update";
  /** 删除 */

  EnumActionType["Delete"] = "delete";
  /** 导入 */

  EnumActionType["Import"] = "import";
  /** 模板 */

  EnumActionType["Template"] = "template";
  /** 导出 */

  EnumActionType["Export"] = "export";
  /** 选择导出 */

  EnumActionType["ExportIds"] = "exportIds";
})(EnumActionType || (EnumActionType = {}));

export { EnumActionType, EnumPlatform };
//# sourceMappingURL=bases.js.map
